import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../css/theme";
import { Font } from "@react-pdf/renderer";
import OpenSansBold from "../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import OpenSansSemiBold from "../../../assets/fonts/Open_Sans/OpenSans-SemiBold.ttf";
import RalewayRegular from "../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayBold from "../../../assets/fonts/Raleway/Raleway-Bold.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
    { src: OpenSansSemiBold, fontWeight: "semibold" },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    {
      src: RalewayRegular,
      fontWeight: "normal",
    },
    {
      src: RalewayBold,
      fontWeight: "bold",
    },
  ],
});

const amlReportStyles = StyleSheet.create({
  page: {
    // gap: 12,
  },

  header: {
    height: 64,
    paddingTop: 12,
    paddingBottom: 12,
    marginBottom: 18,
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: theme.colors.Brand1PenBlue,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footer: {
    position: "absolute",
    bottom: 24,
    left: 0,
    right: 0,
    width: "100%",
    textAlign: "center",
    marginTop: 16,
    // OPTIONAL: add padding if needed
    // paddingHorizontal: 30,
  },
  // amlTextBrand: {
  //   fontFamily: "Raleway",
  //   fontSize: 16,
  //   fontWeight: "bold",
  //   color: theme.colors.White,
  // },

  amlTextHeading: {
    fontFamily: "Raleway",
    fontSize: 12,
    fontWeight: "bold",
    color: theme.colors.Black,
    // lineHeight: 20,
  },

  amlTextSubheading: {
    fontFamily: "Open Sans",
    fontSize: 10,
    fontWeight: "semibold",
    color: theme.colors.Black,
    // lineHeight: 17,
  },
  amlDecisionTextSubheading: {
    fontFamily: "Open Sans",
    fontSize: 12,
    fontWeight: "semibold",
    color: theme.colors.Black,
    // lineHeight: 17,
  },

  amlTextCaption: {
    fontFamily: "Open Sans",
    fontSize: 8,
    fontWeight: "normal",
    color: theme.colors.Black,
    // lineHeight: 14,
  },
  amlTextValue: {
    fontFamily: "Open Sans",
    fontSize: 8,
    fontWeight: "semibold",
    // textTransform: "uppercase",
    color: theme.colors.Black,
  },
  amlTextFooter: {
    fontFamily: "Open Sans",
    fontSize: 9,
    textAlign: "center",
    color: theme.colors.Grey600,
  },
  section: {
    marginTop: 12,
    paddingHorizontal: 24,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 12,
  },
  checkDetailsContainer: {
    width: "100%",
    borderBottomWidth: 1, // proper border syntax for react-pdf
    borderColor: theme.colors.Blue400,
    borderRadius: 5,
    paddingHorizontal: 24,
    paddingVertical: 8,
    flexDirection: "column",
    gap: 30,
    // height:64,
    backgroundColor: theme.colors.Blue400,
  },

  checkDetailsRow: {
    flexDirection: "row",
    gap: 16,
  },
  checkDetailsColumn: {
    flexDirection: "column",
  },

  verticalDivider: {
    width: 1,
    backgroundColor: theme.colors.Grey400,
    height: "100%",
  },
  horizontalDivider: {
    height: 1,
    backgroundColor: theme.colors.Grey400,
    width: "100%",
  },

  headingRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  // redContainer: {
  //   backgroundColor: theme.colors.Red400,
  //   borderRadius: 3,
  //   borderWidth: 3,
  //   borderColor: theme.colors.error,
  //   paddingVertical: 10,
  //   paddingHorizontal: 16,
  //   width: "100%",
  //   height: "auto",
  // },
  reasonContainer: {
    backgroundColor: theme.colors.Red400,
    borderRadius: 3,
    borderLeftColor: theme.colors.error,
    borderLeftWidth: 3,
    // borderRightColor: theme.colors.error,
    // borderRightWidth: 5,
    paddingVertical: 16,
    paddingHorizontal: 20,
    width: "100%",
    height: "auto",
  },
  warningContainer: {
    backgroundColor: theme.colors.Yellow400,
    borderRadius: 3,
    borderLeftColor: theme.colors.Warning,
    borderLeftWidth: 3,
    // borderRightColor: theme.colors.error,
    // borderRightWidth: 5,
    paddingVertical: 16,
    paddingHorizontal: 20,
    width: "100%",
    height: "auto",
  },
  infoContainer: {
    backgroundColor: theme.colors.Blue400,
    borderRadius: 3,
    borderLeftColor: theme.colors.Brand12steplighter,
    // marginTop: 8,
    // marginHorizontal: 24,
    // marginRight: 24,
    borderLeftWidth: 3,
    // borderRightColor: theme.colors.error,
    // borderRightWidth: 5,
    paddingVertical: 16,
    paddingHorizontal: 20,
    width: "100%",
    height: "auto",
  },
  successContainer: {
    backgroundColor: theme.colors.Green400,
    borderRadius: 3,
    borderLeftColor: theme.colors.Success,
    borderLeftWidth: 3,
    // borderRightColor: theme.colors.error,
    // borderRightWidth: 5,
    paddingVertical: 16,
    paddingHorizontal: 20,
    width: "100%",
    height: "auto",
  },
  table: {
    display: "flex",
    width: "100%",
    overflow: "hidden",
    borderWidth: 3,
    borderColor: theme.colors.Grey400,
    borderStyle: "solid",
    borderRadius: 3,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    paddingVertical: 5,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.Grey10,
    borderStyle: "solid",
    flex: 1,
  },
  tableHeader: {
    backgroundColor: theme.colors.Blue400,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.Grey400,
    borderStyle: "solid",
    fontFamily: "Open Sans",
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    fontSize: 10,
    fontWeight: "bold",
  },
  mediaImage: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: "cover",
    borderRadius: 3,
  },
  verticalSizeBox: {
    height: 12,
  },
  footerContainer: {
    width: "100%",
    marginTop: 10,
    borderWidth: 1,
    borderColor: theme.colors.Grey25,
    borderRadius: 3,
    padding: 16,
  },
});

export default amlReportStyles;
